//@flow

// Vendors
import React, { useState } from 'react';
import classnames from 'classnames';

// Components
import { InputGroup, InputPassword, Content } from '../../..';
import InputPasswordReq from './InputPasswordReq';

import './InputGroupConfirmPassword.scss';

type Props = {
  className?: string,
  formikProps: FormikProps,
};

/**
 * @visibleName Confirm Password
 */

const InputGroupConfirmPassword = ({
  className,
  formikProps,
  ...props
}: Props) => {
  const [passwordChecklist, setPasswordChecklist] = useState(false);

  const [containsMinC, setcontainsMinC] = useState(false);
  const [containsUL, setContainsUL] = useState(false);
  const [containsLL, setContainsLL] = useState(false);
  const [containsN, setContainsN] = useState(false);
  const [containsSC, setContainsSC] = useState(false);

  const [allValid, setAllValid] = useState(false);

  const passwordReqData = [
    ['A minimum of 15 characters', containsMinC],
    ['An uppercase letter', containsUL],
    ['A lowercase letter', containsLL],
    ['One number', containsN],
    ['One special character (.[@!#$^&+=](_-){})', containsSC],
  ];
  const validatePassword = updatedPassword => {
    if (updatedPassword.toLowerCase() !== updatedPassword) setContainsUL(true);
    else setContainsUL(false);
    if (updatedPassword.toUpperCase() !== updatedPassword) setContainsLL(true);
    else setContainsLL(false);
    if (/\d/.test(updatedPassword)) setContainsN(true);
    else setContainsN(false);
    if (/[!#$^&+@=\[\]._(){}-]/g.test(updatedPassword)) setContainsSC(true);
    else setContainsSC(false);
    if (updatedPassword.length >= 15) setcontainsMinC(true);
    else setcontainsMinC(false);
    if (containsUL && containsLL && containsN && containsSC && containsMinC)
      setAllValid(true);
    else setAllValid(false);
  };

  const showFocused = () => {
    setPasswordChecklist(!passwordChecklist);
  };

  return (
    <InputGroup
      {...props}
      className={classnames('input-group-confirm-password', className)}
    >
      <InputPassword
        name="password"
        label={<Content type="Labels" id="EnterPassword" />}
        formikProps={formikProps}
        onKeyUp={e => validatePassword(e.target.value)}
        onFocus={showFocused}
        onBlur={showFocused}
        autoComplete="new-password"
        className="input-margin"
        maxLength="64"
        />
      {passwordChecklist && (
        <div className="password-helper-container">
          {passwordReqData.map(data => (
            <InputPasswordReq data={data} />
          ))}
        </div>
      )}

      <InputPassword
        name="confirmPassword"
        label={<Content type="Labels" id="ConfirmPassword" />}
        className="input-password-confirm"
        autoComplete="new-password"
        formikProps={formikProps}
        maxLength="64"
      />
    </InputGroup>
  );
};

export default InputGroupConfirmPassword;
